import { useLocale } from "next-intl";
import Link from "next/link";

export default function PropertyButton({ isHome }: { isHome: boolean }) {
  const locale = useLocale();

  return (
    <div>
      <Link
        href={`${process.env.NEXT_PUBLIC_DEVELOPER_URL}`}
        target="_blank"
        className={`bg-main text-sm text-white border-main px-4 py-2 rounded-lg duration-500 cursor-pointer ${
          !isHome && "hover:bg-transparent hover:text-black border"
        }`}
      >
        {locale === "ar" ? "أضف عقارك" : "Add Your Property"}
      </Link>
    </div>
  );
}
